import { Swiper } from 'swiper';
import 'swiper/css';

export default function gallery() {
    if (document.querySelector('.gallery__images')) {
        initSwiper();
    }
}

const initSwiper = () => {
    return new Swiper('.gallery__images', {
        slidesPerView: 1.2,
        spaceBetween: 16,
        grabCursor: true,
        loop: true,
        breakpoints: {
            768: {
                slidesPerView: 2.2,
                spaceBetween: 16,
            },
            1024: {
                enabled: false,
                slidesPerView: 3,
                spaceBetween: 16,
            },
        },
    });
};
